<template>
    <div>
        <vForm :label-width="120" ref="baseform" :model="formData" class="margin-15 clearfix" v-if="boxtype=='typebol'">
            <vCol span="24">
                <vFormItem label="PickUp Time" prop="pickUpTime" :rules="required">
                    <vDatepicker v-model="formData.pickUpTime" format="yyyy-mm-dd" confirm="false"></vDatepicker>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="Delivery Time">
                    <vDatepicker v-model="formData.deliveryTime" format="yyyy-mm-dd" confirm="false"></vDatepicker>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('global.common.upload', { defaultValue: '上传' })+'bol'" prop="attachTitle" :rules="required">
                    <div v-if="this.attachMetas.items.length>0">
                        {{this.attachMetas.items[0].attachTitle}}
                    </div>
                    <vButton @click="addExcel">{{$t('erp.product.new_add', { defaultValue: "添加" })}}</vButton>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="关联单号" >
                    <div>{{ linkedNo || '--'}}</div>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })">
                    <vTextarea v-model="remark"></vTextarea>
                </vFormItem>
            </vCol>
        </vForm>
        <vForm :label-width="120" ref="form" class="margin-15 clearfix" v-else>
            <vCol span="24">
                <vFormItem :label="$t('global.common.upload', { defaultValue: '上传' })">
                    <div v-if="attachMetas.items.length>0">
                        {{attachMetas.items[0].attachTitle}}
                    </div>
                    <vButton @click="addExcel">{{$t('erp.product.new_add', { defaultValue: "添加" })}}</vButton>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })">
                    <vTextarea v-model="remark"></vTextarea>
                </vFormItem>
            </vCol>
        </vForm>
        <div class="text-right">
            <vButton theme="primary" class="margin-right-10" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
            <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compMutiUpload v-bind="getFileProps" @on-success="aaasuccess" @on-cancel="cancelUpload" />
            <footer slot="footer" v-show="false"></footer>
      </vModal>
    </div>
</template>

<script>
import { HttpBOLTruck,HttpPODTruck,HttpPuDeTruckOne } from "@/service/bespeak";
export default {
    props:['orderid','boxtype','linkedNo'],
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    data(){
        return {
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
            operate: {
                width:460,
                show: false,
                title: this.$t('fbb.headlogistics.attach_upload', { defaultValue: "附件上传" }),
                data: {}
            },
            formData:{},
            remark:'',
            attachMetas:{
                items: [],
                opAt: "",
                organizationId: ""
            },
        }
    },
    computed:{
        getFileProps() {
            return {
                action: process.env.VUE_APP_APIURL_UC + "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.orderid,
                    model: "logistics",
                    type: "other"
                }
            };
        }
    },
    methods:{
        addExcel(){
            this.operate.show = true;
        },
        aaasuccess(res) {
            res.items.forEach(item => {
                this.attachMetas.items.push(item);
            });
            this.attachMetas.opAt = res.opAt;
            this.attachMetas.organizationId = res.organizationId;

            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        async submit(){
            let opAttachMeta = JSON.stringify(this.attachMetas);
            if(this.boxtype == 'typebol'){
                let bool1 = await this.$refs.baseform.validate()
                if (!bool1) return
                if(this.attachMetas.items.length<1){
                    return this.$VMessage.error('上传bol不能为空');
                }
                HttpPuDeTruckOne({
                    id:this.orderid,
                    pickUpTime:this.formData.pickUpTime,
                    deliveryTime:this.formData.deliveryTime,
                }).then(res=>{
                    HttpBOLTruck({
                        id:this.orderid,
                        billNo:this.formData.billNo,
                        remark:this.remark,
                        attachMeta: opAttachMeta
                    }).then(res=>{
                        this.$VMessage.success(res.message);
                        this.$emit('on-update');
                        this.cancel();
                    },err=>{
                        this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        })
                },err=>{
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            }else{
                HttpPODTruck({
                    id:this.orderid,
                    remark:this.remark,
                    attachMeta: opAttachMeta
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.$emit('on-update');
                    this.cancel();
                },err=>{
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                })
            }
        },
        cancel(){
            this.$emit('on-close');
        }
    }
}
</script>
